<template>
  <div class="login-container">
    <div class="login-box">
      <h2>登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input type="text" id="username" v-model="username" required placeholder="请输入用户名" />
        </div>
        <div class="form-group">
          <label for="password">密码</label>
          <input type="password" id="password" v-model="password" required placeholder="请输入密码" />
        </div>
        <div class="form-group">
          <button type="submit" :disabled="loading">
            {{ loading ? '登录中...' : '登录' }}
          </button>
        </div>
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: ''
    };
  },
  created() {
    this.checkTimestamp();
  },
  methods: {
    checkTimestamp() {
      // Check for timestamp query param in window.location (not vue router query)
      // Because the user example is ?timestamp=...#/login
      const searchParams = new URLSearchParams(window.location.search);
      let timestamp = searchParams.get('timestamp');
      
      // Fallback: Check Vue router query (in case it's #/login?timestamp=...)
      if (!timestamp) {
        timestamp = this.$route.query.timestamp;
      }
      
      console.log('Checking timestamp:', timestamp);
      
      if (timestamp) {
        const ts = parseInt(timestamp, 10);
        const now = Date.now();
        const diff = Math.abs(now - ts);
        
        console.log('Current time:', now);
        console.log('Timestamp:', ts);
        console.log('Difference (ms):', diff);
        
        // Check if timestamp is within 1 minute (60000ms)
        // Allowing some clock skew or delay, user said "within 1 minute"
        // We assume timestamp is in the past or very close to now.
        if (!isNaN(ts) && diff <= 60000) {
           console.log('Timestamp valid. Logging in...');
           // Valid timestamp, auto-login
           sessionStorage.setItem('isAuthenticated', 'true');
           // Since we don't have company_id, we just go to root home
           // Redirect to home and clear query parameters
           window.location.href = window.location.origin + window.location.pathname + '#/';
        } else {
           console.warn('Timestamp invalid or expired.');
           this.error = '链接已失效 (Timestamp expired)';
        }
      }
    },
    async handleLogin() {
      this.loading = true;
      this.error = '';

      try {
        const response = await axios.post('https://company.hbqhts.com/api/v1/auth/login', {
          username: this.username,
          password: this.password
        });

        // Assuming the API returns a token or success indicator.
        // Adjust this based on actual API response structure.
        // For now, if status is 200, we consider it success.
        // If the API returns a token, we should store it.
        
        console.log('Login response:', response);

        if (response.status === 200) {
            // Save token if available, e.g., response.data.token
            // For now just marking as authenticated
            // localStorage.setItem('isAuthenticated', 'true');
            if (response.data && response.data.data && response.data.data.token) {
                localStorage.setItem('token', response.data.data.token);
            }
            
            sessionStorage.setItem('isAuthenticated', 'true');
            
            const companyId = response.data.data.company_id;
            // Redirect to /companyId/#/
            window.location.href = '/' + companyId + '/#/';
        } else {
            this.error = '登录失败，请检查用户名或密码';
        }

      } catch (err) {
        console.error('Login error:', err);
        this.error = err.response?.data?.message || '登录请求失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #2d3a4b; /* Dark background */
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
}

h2 {
  text-align: center;
  margin-bottom: 24px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #666;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box; /* Ensure padding doesn't affect width */
  font-size: 1.4rem;
}

input:focus {
  border-color: #409eff;
  outline: none;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.6rem;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #66b1ff;
}

button:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.error-message {
  color: #f56c6c;
  text-align: center;
  margin-top: 10px;
  font-size: 1.4rem;
}
</style>
